import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import { awaitViewTransitionsCompleted } from "../utils/viewTransition";

export default class Content extends AlpineComponent {
  constructor() {
    super();
  }

  init() {
    this.enforceSelectedVisible("init");
  }

  destroy() { }

  getContainer(elem: HTMLElement): HTMLElement | null {
    let parent = elem.parentElement;
    while (parent !== null && parent.id !== "termlynx-parser-doc") {
      if (parent.hasAttribute("data-block-index")) {
        return parent;
      }
      parent = parent.parentElement;
    }
    return null;
  }

  enforceSelectedVisible(source: string = "unknown") {
    console.log(`[Content] enforceSelectedVisible from: ${source} | viewTransitionName: "${this.$el.style.viewTransitionName}"`);
    const selected = this.$el.querySelector(".selected") as HTMLElement;
    if (selected === null) {
      console.log("[Content]   → no .selected element found, skipping");
      return;
    }
    const container = this.getContainer(selected);
    if (container === null) return;

    const eRect = this.$el.getBoundingClientRect();
    const cRect = container.getBoundingClientRect();
    const sRect = selected.getBoundingClientRect();

    const delta =
      // is the distance between the top of the paragraph and the bottom of the
      // selection bigger than the explorer-content's height?
      sRect.bottom - cRect.top > eRect.height
        ? // Align the bottom of the explorer-content to the bottom of the selection
        // with 2px extra margin, aka a line height.
        sRect.bottom - eRect.bottom + 2
        : // Align the top of the explorer-content to the top of the block containing
        // the selected with a 4px extra margin, aka half of a scrolling detection padding
        cRect.y - eRect.y - 4;

    console.log(`[Content]   → scrollBy delta: ${delta}`);
    this.$el.scrollBy({ top: delta, behavior: "instant" });

    // X-axis: scroll the .grid inside a grid-container
    const grid = container.querySelector(':scope > .grid') as HTMLElement | null;
    if (grid) {
      const gRect = grid.getBoundingClientRect();
      const deltaX = sRect.right > gRect.right
        ? sRect.right - gRect.right + 4
        : sRect.left < gRect.left
          ? sRect.left - gRect.left - 4
          : 0;
      if (deltaX !== 0) {
        grid.scrollBy({ left: deltaX, behavior: "instant" });
      }
    }
  }

  async onContentChanged(e: CustomEvent<{ value: string }>) {
    if (e.detail.value !== this.$el.id) return;
    console.log(`[Content] onContentChanged | viewTransitionName: "${this.$el.style.viewTransitionName}"`);
    requestAnimationFrame(() => {
      this.enforceSelectedVisible("onContentChanged-timeout");
    })
  }
}
